import React from 'react'
import { AccordionContainer } from '../../../../common/components/accordion/accordion.module'
import { InputContainer } from '../../../../common/components/form/form.module'


export default function OneUserProfileInfoComponent ({handleInnerFormChange, selectedOneUser}: any) {

  return (
    <>
      <AccordionContainer
    child={
      <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
           
           <InputContainer
              label="FirstName"
              name="FirstName"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'UserProfile.FirstName',
                  selectedOneUser?.UserProfile
                )
              }}
              type="text"
              value={selectedOneUser?.UserProfile?.FirstName}
          />
    
          <InputContainer
              label="LastName"
              name="LastName"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'UserProfile.LastName',
                  selectedOneUser?.UserProfile
                )
              }}
              type="text"
              value={selectedOneUser?.UserProfile?.LastName}
          />

          <InputContainer
              label="PersonTitle"
              name="PersonTitle"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'UserProfile.PersonTitle',
                  selectedOneUser?.UserProfile
                )
              }}
              type="text"
              value={selectedOneUser?.UserProfile?.PersonTitle}
          />
        
     </div>
  }
    expandedPanel="userInfo"
    headerTitle="User Profile"
/>

        </>
  )
}